export default __webpack_public_path__ + "static/terms-82a4c527f485c4d2a21d609f18e3bc6c.pdf";